import i18n from './i18n'

/**
 * Canonical badge metadata for the web app.
 * Mirrors BADGE_META in apps/mobile/src/types/index.ts.
 *
 * Keys match the UserDTO.badges[] values returned by the backend UserResource.
 * The display labels live in brand.json (reserved vocabulary - English in every
 * locale); the values below are a fallback only.
 */
export const BADGE_META = {
  ghost:   { label: 'Ghost', color: '#888',    bg: 'rgba(255,255,255,0.06)', border: 'rgba(255,255,255,0.10)' },
  fresh:   { label: 'Fresh', color: '#4ade80', bg: 'rgba(74,222,128,0.12)',  border: 'rgba(74,222,128,0.22)'  },
  regular: { label: 'Crew',         color: '#60a5fa', bg: 'rgba(96,165,250,0.12)',  border: 'rgba(96,165,250,0.22)'  },
  host:    { label: 'Legend',  color: '#fbbf24', bg: 'rgba(251,191,36,0.15)',  border: 'rgba(251,191,36,0.28)'  },
}

/** Returns the display label for a badge key (brand.json - never translated). */
export function badgeLabel(key) {
  return i18n.t(`badge.${key}`, { ns: 'brand', defaultValue: BADGE_META[key]?.label ?? key })
}
